import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
	isLogged: boolean;
	isPermitted: boolean;
	fallbackRoute: string;
}

const ProtectedRoute = ({ isLogged, isPermitted, fallbackRoute }: ProtectedRouteProps) => {
	if (!isLogged) {
		return <Navigate to="/app/authentication/signIn" replace />;
	}
	if (!isPermitted) {
		return <Navigate to={fallbackRoute} replace />;
	}
	return <Outlet />;
};

export default ProtectedRoute;
